import { useNavigatePrompt } from 'utils/url/useNavigatePrompt';

export type NavigatePromptProps = {
  /** Boolean indicating whether the prompt should be trigger upon navigation. */
  when: boolean;
  /** Custom text message to display in the prompt. */
  message?: string;
};

export const NavigatePrompt = ({
  when,
  message,
}: NavigatePromptProps): null => {
  useNavigatePrompt(when, message);
  return null;
};
